import { createRoute } from '@tanstack/react-router'
import { publicLayoutRoute } from '@/ui/pages/public'
import { RegisterFormSection } from './components/RegisterFormSection'
import { RegisterHeader } from './components/RegisterHeader'

export const publicRegisterRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: 'register',
  component: PublicRegisterPage,
})

/**
 * Public registration page. Pure layout shell that composes the branding
 * header and the registration form section — all state and logic live in
 * the section components.
 */
export function PublicRegisterPage() {
  return (
    <div className="flex-1 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md space-y-8">
        <RegisterHeader />
        <RegisterFormSection />
      </div>
    </div>
  )
}
